// state
export const state = {
  isModalOpen: false,
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  setClaimBonusModalVisibility(state, { isVisible }) {
    state.isModalOpen = isVisible
  },
}
// actions
export const actions = {
  async openClaimBonusModal({ commit }) {
    commit('setClaimBonusModalVisibility', { isVisible: true })
  },
  async closeClaimBonusModal({ commit }) {
    commit('setClaimBonusModalVisibility', { isVisible: false })
  },
}
